module.exports = __webpack_public_path__ + "static/media/download-apk.bd13093f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/download-apk.png
// module id = 527
// module chunks = 0